import { defineProjectsProjectDetailLauncher } from '@crest/module-projects/contracts/detail-launcher';
import { relationshipsConsumedProjectsDetailHostCapability, relationshipsConsumedProjectsDetailSummarySlot, relationshipsProjectCustomerHostContributionId, } from '../contracts/relationships-project-customer.contract.js';
import { relationshipsModuleManifest } from '../relationships.module.js';
import { relationshipsSettingRegistrations } from '../settings/relationships-setting-definitions.js';
export const relationshipsWebModuleContribution = {
    moduleId: 'relationships',
    manifest: relationshipsModuleManifest,
    settingRegistrations: relationshipsSettingRegistrations,
    settingEditors: [],
    hostContracts: [],
    hostContributions: [{
            id: relationshipsProjectCustomerHostContributionId,
            moduleId: 'relationships',
            slot: relationshipsConsumedProjectsDetailSummarySlot,
            contractVersion: relationshipsConsumedProjectsDetailHostCapability,
            requiredPermission: 'relationships.contacts.read',
            settingCondition: {
                key: 'relationships.projects.customer-panel.enabled',
                property: null,
                equals: true,
            },
            priority: 20,
            errorBehavior: 'inline',
            emptyBehavior: 'inline',
            launcher: defineProjectsProjectDetailLauncher({
                fallbackLabel: 'Customer',
                fallbackDescription: 'Open customer, contact, and organization details for this Project.',
                defaultSize: 'wide',
                supportedSizes: ['standard', 'wide', 'large'],
            }),
            load: () => import('./relationships-project-customer-panel.js'),
        }],
    routes: [
        {
            id: 'relationships.web.contact-detail', moduleId: 'relationships',
            path: '/relationships/contacts/:contactId', requiredPermission: 'relationships.contacts.read',
            // Platform requires explicit null for deep links that are not navigation entries.
            navigation: null,
            load: () => import('./relationships-contact-detail.page.js'),
        },
        {
            id: 'relationships.web.contacts',
            moduleId: 'relationships',
            path: '/relationships/contacts',
            requiredPermission: 'relationships.contacts.read',
            navigation: {
                id: 'relationships.navigation.contacts',
                fallbackLabel: 'Contacts',
                labelConfigurationKey: 'relationships.copy.contacts',
                labelValueProperty: 'navigationLabel',
                priority: 20,
            },
            load: () => import('./relationships-contacts.page.js'),
        },
        {
            id: 'relationships.web.organizations',
            moduleId: 'relationships',
            path: '/relationships/organizations',
            requiredPermission: 'relationships.contacts.read',
            navigation: {
                id: 'relationships.navigation.organizations',
                fallbackLabel: 'Organizations',
                labelConfigurationKey: 'relationships.copy.organizations',
                labelValueProperty: 'navigationLabel',
                priority: 21,
            },
            load: () => import('./relationships-organizations.page.js'),
        },
        {
            id: 'relationships.web.organization-detail', moduleId: 'relationships',
            path: '/relationships/organizations/:organizationId', requiredPermission: 'relationships.contacts.read',
            navigation: null,
            load: () => import('./relationships-organization-detail.page.js'),
        },
        {
            id: 'relationships.web.leads',
            moduleId: 'relationships',
            path: '/relationships/leads',
            requiredPermission: 'relationships.leads.read',
            navigation: {
                id: 'relationships.navigation.leads',
                fallbackLabel: 'Leads',
                labelConfigurationKey: 'relationships.copy.leads',
                labelValueProperty: 'navigationLabel',
                priority: 22,
            },
            load: () => import('./relationships-leads.page.js'),
        },
    ],
};
export default relationshipsWebModuleContribution;
//# sourceMappingURL=relationships-web.module-contribution.js.map